import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function BandCtaSection({
  id = 'cta',
  title,
  subtitle,
  placeholder,
  submitLabel,
  emailLabel,
  onSubmit,
}) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    if (typeof onSubmit === 'function') {
      onSubmit(email);
    }
  }, [email, onSubmit]);

  return (
    <section className="band-cta" id={id}>
      <div className="band-cta__container">
        <h2 className="band-cta__title">{title || t('bandPage.cta.title')}</h2>
        <p className="band-cta__sub">{subtitle || t('bandPage.cta.subtitle')}</p>
        <form className="band-cta__form" onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder={placeholder || t('bandPage.cta.placeholder')}
            aria-label={emailLabel || t('bandPage.cta.emailLabel')}
          />
          <button type="submit" className="band-cta__submit">
            {submitLabel || t('bandPage.cta.submit')}
          </button>
        </form>
      </div>
    </section>
  );
}

BandCtaSection.propTypes = {
  id: PropTypes.string,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  placeholder: PropTypes.string,
  submitLabel: PropTypes.node,
  emailLabel: PropTypes.string,
  onSubmit: PropTypes.func,
};
